// src/utils/debugApplicant.js
export const debugApplicantPayload = (label, data) => {
  const a = data?.applicant ?? {};
  const j = data?.job ?? {};
  console.group(`[BF] ${label}`);
  console.log('CRM status (old):', a?.status?.description);
  console.log('COMPLIANCE status (BQ):', a?.file_sign_off_status);
  console.log('COMPLIANCE expiry (BQ):', a?.expiry_date);
  console.log('PositionId:', a?.position_id, '— positions:', a?.positions);
  console.log('Job.title:', j?.title);
  console.log('Job.position_id:', j?.position_id, '— positions:', j?.positions);
  console.groupEnd();
};
